import { useEffect, useState } from "react";
import { fetchAlergenosAll } from "../api/alergenosApi";
import { fetchPersonasAll } from "../api/personasApi";

export function useAlergenosData() {
    const [alergenos, setAlergenos] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                setLoading(true);
                setError("");

                const [als, pers] = await Promise.all([fetchAlergenosAll(), fetchPersonasAll()]);

                if (!mounted) return;
                setAlergenos(Array.isArray(als) ? als : []);
                setPersonas(Array.isArray(pers) ? pers : []);
            } catch (e) {
                if (!mounted) return;
                setError(e?.message || "Error cargando datos");
            } finally {
                if (mounted) setLoading(false);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    return { alergenos, personas, loading, error };
}
